export const ConvertObjectKeysToArray = (object) => Object.keys(object).filter((key) => object[key])
export const ConvertArrayToString = (array) => array.join()
